import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';

const L = logger('fromAnyToLocalPath');

const DEFAULT_RESULT = '#';
const DEFAULT_BASE = 'https://localhost/';

const fromAnyToLocalPath = (any) => {
  try {
    const trimmed = fromAnyToTrimmed(any);
    if (!trimmed) return DEFAULT_RESULT;

    // the base is irrelevant as long as it has no path in it since we're only interested in the path itself
    const url = new URL(trimmed, DEFAULT_BASE);

    return url.pathname || DEFAULT_RESULT;
  } catch (e) {
    L.warn('()', e);
    return DEFAULT_RESULT;
  }
};

// noinspection JSUnusedGlobalSymbols
export default fromAnyToLocalPath;
